<template>
    <div class="col-md-9">
        <div class="pages__title-holder mb-3">
            <h1 class="pages__title m-0">news</h1>
            <div class="d-flex align-items-center">
                <a href="/admin/panel/news/create" class="btn btn_golden mr-1"><span>+ Add New</span></a>
                <button
                    class="btn btn_red"
                    @click="showCustomModal('deleteFew', 1)"
                >
                    bulk Delete
                </button>
            </div>
        </div>
        <div class="filter m-0">
            <form>
                <div class="row justify-content-between">
                    <div class="col-md-6">
                        <div class="artists__search">
                            <input
                                type="text"
                                class="txt"
                                placeholder="Search"
                                v-model="filters.search"
                                @keydown.enter="fetchListOfNews"
                            >
                            <button
                                type="submit"
                                class="sbm"
                                @click.prevent="fetchListOfNews"
                            >
                                <svg width="18" height="18" class="icon">
                                    <use href="/img/svg/symbol-defs.svg#icon-search"></use>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div class="col-6 col-md-3">
                        <div class="filter__item">
                            <div class="form">
                                <div class="show-num">
                                    <label class="show-num__label">Show:</label>
                                    <select
                                        class="custom-select pl-3"
                                        @change="fetchListOfNews"
                                        v-model="filters.perPage"
                                    >
                                        <option value="10">10</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="pages__table">
            <div class="pages__top">
                <div class="check">
                    <label for="" class="checkbox">
                        <input type="checkbox" @change="checkAll" v-model="isCheckedAll">
                        <span></span>
                    </label>
                </div>
                <div class="title-page">
                    Title
                </div>
                <div class="slug">
                    Slug
                </div>
                <div class="image">
                    Image
                </div>
                <div class="text">
                    Text
                </div>
                <div class="created">
                    <a href="javascript:void(0)" @click.prevent="changeSortList('created_at')">Created at <i class="fa-solid fa-sort"></i></a>
                </div>
                <div class="action">

                </div>
            </div>
            <ul class="pages__list">
                <li
                    class="pages__line"
                    v-for="(news, index) in listOfNews"
                    :key="news.id"
                >
                    <div class="check">
                        <label for="" class="checkbox">
                            <input type="checkbox" v-model="news.isChecked" @click="checkNews(news.id, index)">
                            <span></span>
                        </label>
                    </div>
                    <div class="title-page">
                        <p class="clipped">{{ news.title }}</p>
                    </div>
                    <div class="slug">
                        <p class="clipped"> {{ news.slug }}</p>
                    </div>
                    <div class="image">
                        <img :src="getNameOfAvatar(news.slider_images[0])" alt="photo">
                    </div>
                    <div class="text">
                        <p class="clipped"> {{ news.content }}</p>
                    </div>
                    <div class="created">
                        <p>{{ formatIsoDateString(news.created_at) }}</p>
                    </div>
                    <div class="action">
                        <div class="action__hold">
                            <a :href="`/admin/panel/news/${news.id}/edit`" class="edit">
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-edit"></use>
                                </svg>
                            </a>
                            <a class="delete" @click.prevent="openDeleteModal(news.id)">
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                                </svg>
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <ActionModal
            :modal-id="getCustomModalId('delete',currentNewsId)"
            @confirm="deleteNews(currentNewsId)"
            :reject-text="`No`"
            :confirm-text="`Yes`"
        >
            <template #body>
                <div class="text-center mb-4">
                    <div class="text-center">
                        <h5 class="title">Are you sure ?</h5>
                        <p>Do you want to delete this news?</p>
                    </div>
                </div>
            </template>
        </ActionModal>

        <ActionModal
            :modal-id="getCustomModalId('deleteFew', 1)"
            @confirm="deleteFewNews"
            :reject-text="`No`"
            :confirm-text="`Yes`"
        >
            <template #body>
                <div class="text-center mb-4">
                    <div class="text-center">
                        <h5 class="title">Are you sure ?</h5>
                        <p>Do you want to delete these news?</p>
                    </div>
                </div>
            </template>
        </ActionModal>

        <Pagination
            :last-page="pagination.last_page"
            :current-page="pagination.current_page"
            @changePage="changePage"
        />
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import AdminPanelService from "../../../services/AdminPanelService";
import ActionModal from "../../Common/ActionModal.vue";
import ModalHandler from "../../../mixins/ModalHandler";
import Pagination from "../../Common/Pagination.vue";
import DateHandler from "../../../mixins/DateHandler";

export default defineComponent({
    name: "News",
    components: {Pagination, ActionModal},
    mixins: [ModalHandler, DateHandler],
    data() {
        return {
            isCheckedAll: false,
            listOfNews: [],
            checkedNews: [],
            currentNewsId: null,
            filters: {
                search: '',
                page: 1,
                perPage: 10,
                orderColumn: 'created_at',
                orderDirection: 'asc'
            },
            pagination: {
                last_page: null,
                current_page: null
            }
        }
    },
    methods: {
        getNameOfAvatar(photo) {
            return photo ? `/uploads${photo.file_path}` : "/img/svg/avatar.svg";
        },
        checkAll() {
            const value = this.isCheckedAll
            this.listOfNews.forEach(item => {
                item.isChecked = value
            })

            if (value) {
                this.checkedNews = this.listOfNews.map(item => item.id)
            } else {
                this.checkedNews = []
            }
        },
        checkNews(id) {
            const index = this.checkedNews.indexOf(id)

            if (index !== -1) {
                this.checkedNews.splice(index, 1)
            } else {
                this.checkedNews.push(id)
            }

            const newsItem = this.listOfNews.find(item => item.id === id)
            if (newsItem) {
                newsItem.isChecked = this.checkedNews.includes(id)
            }
        },

        changeSortList(field) {
            if (this.filters.orderColumn === field) {
                this.filters.orderDirection = this.filters.orderDirection === 'asc' ? 'desc' : 'asc';
            }
            this.filters.orderColumn = field
            this.fetchListOfNews(this.filters)
        },
        changePage(page) {
            this.filters.page = page
            this.fetchListOfNews(this.filters)
        },
        async fetchListOfNews() {
            try {
                const { data: response } = await AdminPanelService.fetchListOfNews(this.filters)
                this.listOfNews = response.data
                this.listOfNews.forEach(news => news.isChecked = false)
                this.pagination.current_page = response.current_page
                this.pagination.last_page = response.last_page
            } catch (e) {
                console.error(e)
            }
        },
        openDeleteModal(id) {
            this.currentNewsId = id
            this.$nextTick(()=> {
                this.showCustomModal('delete', id)
            })
        },
        async deleteNews(newsId) {
            try {
                await AdminPanelService.deleteNews(newsId)
                this.$showSuccessMessage('The news was deleted')
                await this.fetchListOfNews()
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The News was not deleted. Please try again')
            }
        },
        async deleteFewNews() {
            try {
                await AdminPanelService.deleteFewNews(this.checkedNews)
                this.$showSuccessMessage('The news was deleted')
                await this.fetchListOfNews()
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The News was not deleted. Please try again')
            }
        }
    },
    mounted() {
        this.fetchListOfNews()
    }
})
</script>



<style scoped>

</style>
